export default {
  name: 'CardTip',
  props: {
    tipInfo: String,
    width: String,
    mleft: String
  }
};